<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Reasignar Caja' : 'Asignar Caja' }}</span></h3>
          </v-card-title>
          <v-card-text>
                <v-select
                  v-model="form.user_id"
                  :items="users_permited"
                  item-text="name"
                  item-value="id"
                  label="Usuario"
                  single-line
                ></v-select>

                <v-select
                  v-model="form.cash_id"
                  :items="cashes"
                  item-text="name"
                  item-value="id"
                  label="Caja"
                  single-line
                ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : 'Crear' }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {
  name: 'form-role-view',

  props: {
    loading: {
      type: Boolean,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    datos: {
      type: Object,
      required: true
    }
  },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear") {
        Object.assign(this.form, this.formOld)
      }else {
        Object.assign(this.form, v)
      }
    }
  },

  data: () => ({
    valid: false,
    cashes: [],
    users_permited: [],
    form: new Form({
        user_id: '',
        cash_id: '',
        observation: ''
    }),
    formOld:{
        user_id: '',
        cash_id: '',
        observation: ''
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
    this.getDataForm()
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('responseLoading', true)
        this.submitFormCashes()
      }
    },

    async getDataForm () {
        this.$emit('responseLoading', true)
        await axios.get('/api/administration/cajas/cajas-users').then(resp => {
            console.log(resp.data)
            this.cashes = resp.data.cash
            this.users_permited = resp.data.users_permited
        })
        .catch(error => { console.log(error.response) })
        .finally(() => this.$emit('responseLoading', false));
    },

    async submitFormCashes () {
      try {
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/administration/cajas/create-assing-cash', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch('/api/administration/cajas/update-assing-cash', this.form)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.$emit('responseLoading', false)
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.cash_id) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.cash_id[0]
            })
          }else if (e.response.data.errors.user_id) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.user_id[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }
    },

    cerrarDialog (data) {
      this.$emit('closeDialogCaja', data)
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.$emit('responseLoading', false)
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/FormCajas.vue